<template>
  <div
    v-if="faskes != 2"
  >
    <!-- kalau tampilan dashboard pic / manajemen -->
    <template v-if="hasFeatures('pic') || hasFeatures('manajemen')">
      <div class="row mb-3">
        <div class="col-md-12">
          <h4
            style="color:#5c8cbd;font-weight:700;font-size:14px"
            class="text-uppercase"
          >
            beranda/dashboard
          </h4>
        </div>
        <div class="col-md-8 mb-2">
          <strong style="font-weight:800;font-size:20px">
            Dashboard {{ dataKlinik.name }}
          </strong>
        </div>
        <div class="col-md-4 mb-2">
          <strong style="font-weight:800;font-size:20px">
            Hari ini, {{ nowIndonesia }}
          </strong>
        </div>
        <div class="col-md-8 text-white p-2">
          <div class="background-image" style="border-radius: 15px; height: 97%;">
            <div class="font-outer-text px-4 pt-4" style="width: 60%;">
              Halo {{ nama }}!
            </div>
            <div
              class="font-sub-outer-text px-4 pb-4"
              v-if="dataKlinik.kota_detail == null"
            >
              Selamat datang <br />
              di {{ dataKlinik.name }}
            </div>
            <div class="font-sub-outer-text px-4 pb-4" v-else>
              Selamat datang <br />
              di {{ dataKlinik.name }}, <br />
              {{ dataKlinik.kota_detail.nama }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card pb-2" style="height:94%">
            <div class="card-body">
              <strong>Profil</strong>
              <div class="text-center">
                <img
                  v-if="
                    dataKlinik.foto_klinik == null ||
                      dataKlinik.foto_klinik == '' ||
                      hasFeatures('manajemen')
                  "
                  src="@/assets/img/icon_logo.png"
                  alt="selamat datang di klinik"
                  class="img-fluid img-welcome"
                />
                <img
                  v-else
                  :src="dataKlinik.foto_klinik"
                  alt="selamat datang di klinik"
                  class="img-fluid img-welcome p-3 img-profile"
                />
                <p class="_text-profile m-0">
                  {{ dataKlinik.name }}
                </p>
                <p style="color:#909399;" class="m-0" v-if="hasFeatures('pic')">
                  {{ dataKlinik.faskes_name || null }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ilham -->
      <template v-if="hasFeatures('manajemen')">
        <Manajemen />
      </template>

      <!-- yusuf -->
      <template v-if="hasFeatures('pic')">
        <Pic />
      </template>

    </template>
    <template v-else-if="hasFeatures('kasir')">
      <div class="row mb-3">
        <div class="col-md-12">
          <h4
            style="color:#5c8cbd;font-weight:700;font-size:14px"
            class="text-uppercase"
          >
            beranda/dashboard
          </h4>
        </div>
        <div class="col-md-8 mb-2">
          <strong style="font-weight:800;font-size:20px">
            Dashboard {{ dataKlinik.name }}
          </strong>
        </div>
        <div class="col-md-4 mb-2">
          <strong style="font-weight:800;font-size:20px">
            Hari ini, {{ nowIndonesia }}
          </strong>
        </div>
        <div class="col-md-8 text-white p-2">
          <div class="background-image" style="border-radius: 15px; height: 97%;">
            <div class="font-outer-text px-4 pt-4" style="width: 60%;">
              Halo {{ nama }}!
            </div>
            <div
              class="font-sub-outer-text px-4 pb-4"
              v-if="dataKlinik.kota_detail == null"
            >
              Selamat datang <br />
              di {{ dataKlinik.name }}
            </div>
            <div class="font-sub-outer-text px-4 pb-4" v-else>
              Selamat datang <br />
              di {{ dataKlinik.name }}, <br />
              {{ dataKlinik.kota_detail.nama }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card pb-2" style="height:94%">
            <div class="card-body">
              <strong>Profil</strong>
              <div class="text-center">
                <img
                  v-if="
                    dataKlinik.foto_klinik == null ||
                      dataKlinik.foto_klinik == '' ||
                      hasFeatures('manajemen')
                  "
                  src="@/assets/img/icon_logo.png"
                  alt="selamat datang di klinik"
                  class="img-fluid img-welcome"
                />
                <img
                  v-else
                  :src="dataKlinik.foto_klinik"
                  alt="selamat datang di klinik"
                  class="img-fluid img-welcome p-3 img-profile"
                />
                <p class="_text-profile m-0">
                  {{ dataKlinik.name }}
                </p>
                <p style="color:#909399;" class="m-0" v-if="hasFeatures('pic')">
                  {{ dataKlinik.faskes_name || null }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Kasir />
    </template>

    <!-- kalau tampilan dashboard selain pic / manajemen -->
    <div class="row" v-else-if="hasFeatures('lainya')">
      <div class="col-md-12">
        <h4 style="color:#5c8cbd" class="text-uppercase">beranda/dashboard</h4>
        <br />
      </div>
      <div class="col-md-4">
        <date-picker :value="Date()" is-expanded locale="id"></date-picker>
      </div>
      <div class="col-md-8">
        <div
          class="background-image-staff"
          style="border-radius: 20px;height: 105%;"
        >
          <div class="font-outer-text px-4 pt-4" style="width: 60%;">
            Halo {{ nama }}!
          </div>
          <div
            class="font-sub-outer-text px-4 pb-4"
            v-if="dataKlinik.kota_detail == null"
          >
            Selamat datang <br />
            di {{ dataKlinik.name }}
          </div>
          <div class="font-sub-outer-text px-4 pb-4" v-else>
            Selamat datang <br />
            di {{ dataKlinik.name }}, <br />
            {{ dataKlinik.kota_detail.nama }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <b-row class="my-4">
      <b-col>
        <div>
          <ol class="d-inline-block breadcrumb text-uppercase font-size-xs p-0">
            <li class="d-inline-block breadcrumb-item">
              <a href="javascript:void(0);">Beranda</a>
            </li>
            <li
              class="d-inline-block breadcrumb-item active"
              aria-current="page"
            >
              dashboard
            </li>
          </ol>
          <div class="d-sm-flex flex-row align-items-center">
            <h5
              class="display-4 mt-1 mb-1 font-weight-bold text-capitalize flex-grow-1"
            >
              dashboard
            </h5>
            <h5 class="display-4 mt-1 mb-1 font-weight-bold text-capitalize">
              Hari ini, {{ nowIndonesia }}
            </h5>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="align-items-center mb-2 mb-lg-0">
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center w-100 mr-2">
            <CardDashboard
              title="total pasien hari ini"
              :highlight="totalPasienHariIni"
              bg-color="total-pasien-hari-ini"
              :goTo="{ name: 'antrean-rawat-jalan' }"
            />
          </div>
          <div class="d-flex align-items-center w-100 mr-2">
            <CardDashboard
              title="pasien baru hari ini"
              :highlight="pasienBaruHariIni"
              bg-color="pasien-baru-hari-ini"
              :goTo="{ name: 'antrean-rawat-jalan' }"
            />
          </div>
          <div class="d-lg-flex align-items-center w-100 mr-2 d-none">
            <CardDashboard
              title="no. antrean saat ini"
              :highlight="nomor_antrean"
              bg-color="no-antrean-saat-ini"
              :goTo="{ name: 'antrean-rawat-jalan' }"
            />
          </div>
          <div class="d-flex align-items-center w-100">
            <CardDashboard
              title="jumlah pasien batal hari ini"
              :highlight="pasienBatalHariIni"
              bg-color="jumlah-pasien-batal-hari-ini"
              :goTo="{ name: 'antrean-rawat-jalan' }"
            />
          </div>
          <div class="d-lg-flex align-items-center w-100 ml-2 d-none">
            <CardDashboard
              title="total pendapatan hari ini"
              :highlight="totalPendapatan"
              bg-color="total-pendapatan-hari-ini"
              :pointerHover="false"
              :showArrow="false"
            >
              <template v-slot:highlight>
                <p
                  style="font-size: 1.5rem; font-weight: 700; word-break: break-word"
                >
                  {{ totalPendapatan }}
                </p>
              </template>
            </CardDashboard>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="align-items-center mb-5">
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <div class="d-lg-none align-items-center w-100 mr-2 d-sm-flex">
            <CardDashboard
              title="no. antrean saat ini"
              :highlight="nomor_antrean"
              bg-color="no-antrean-saat-ini"
              :goTo="{ name: 'antrean-rawat-jalan' }"
            />
          </div>
          <div class="d-lg-none align-items-center w-100 d-sm-flex">
            <CardDashboard
              title="total pendapatan hari ini"
              :highlight="totalPendapatan"
              bg-color="total-pendapatan-hari-ini"
              :pointerHover="false"
              :showArrow="false"
            >
              <template v-slot:highlight>
                <p
                  style="font-size: 1.5rem; font-weight: 700; word-break: break-word"
                >
                  {{ totalPendapatan }}
                </p>
              </template>
            </CardDashboard>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9" sm="12" class="align-self-start">
        <b-tabs content-class="pt-3 pb-2" lazy class="tab-izd-home">
          <b-tab title="List Antrean" active>
            <div slot="title">
              list antrean
            </div>
            <list-antrean />
          </b-tab>
          <b-tab title="List Pembayaran">
            <div slot="title">
              list pembayaran
            </div>
            <list-pembayaran />
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col md="3" sm="12" class="paket-wrapper">
        <Paket
          :sisa_hari="paketAnda.sisa_hari"
          :habis_berlaku="paketAnda.habis_berlaku"
          :nama_paket="paketAnda.nama_paket"
          :paket="paketAnda.durasi_paket"
          :sisa_kouta="paketAnda.sisa_kouta"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <LaporanPendapatan />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("id");

import { library } from "@fortawesome/fontawesome-svg-core";
import { faMoneyCheckAlt } from "@fortawesome/free-solid-svg-icons";
library.add(faMoneyCheckAlt);

import DatePicker from "v-calendar/lib/components/date-picker.umd";
Vue.component("date-picker", DatePicker);

export default {
  name: "home",
  props: ["cekAlamat"],
  components: {
    DatePicker,
    Pic: () => import("@/views/Home/Pic"),
    Kasir: () => import("@/views/Home/Kasir"),
    Manajemen: () => import("@/views/Home/Manajemen"),
    ListAntrean: () => import("@/views/Home/ListAntrean"),
    ListPembayaran: () => import("@/views/Home/ListPembayaran"),
    CardDashboard: () => import("@/components/CardDashboard"),
    LaporanPendapatan: () => import("@/views/Home/LaporanPendapatan"),
    Paket: () => import("@/views/Home/Paket"),
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("REMINDER");
    document
      .getElementsByClassName("app-header")[0]
      .style.setProperty("z-index", 88);
    next();
  },
  data: () => ({
    nomor_antrean: 0,
    totalPasienHariIni: 0,
    pasienBaruHariIni: 0,
    pasienBatalHariIni: 0,
    totalPendapatan: 0,
    paketAnda: {},
    dataKlinik: {},
    dataProfile: {},
    nama: null
  }),
  mounted() {
    if (localStorage.getItem("survey") == "true") {
      this.$router.push(`/init-klinik`);
    } else if (localStorage.getItem("klinik") == "true") {
      this.$router.push(`/init-klinik`);
    }

    Promise.all([this.cekPaketNolock(), this.dashboardPasien()]);

    if (this.$router.currentRoute.query.cekPopUpReminder) {
      this.$swal({
        text: `Kuota WhatsApp/SMS Patient Engagement Anda akan segera habis! Tambah kuota sekarang untuk tetap terhubung dengan pasien Anda!`,
        type: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(dats => {
        if (dats.value) {
          this.$router.push(`/subskripsi`);
        }
      });
    }

    if (this.$router.currentRoute.query.cekPopUpReminderHabis) {
      this.$swal({
        text: `Kuota WhatsApp/SMS Patient Engagement Anda telah HABIS! Tambah kuota sekarang untuk tetap terhubung dengan pasien Anda!`,
        type: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(dats => {
        if (dats.value) {
          this.$router.push(`/subskripsi`);
        }
      });
    }
  },
  async created() {
    await this.getProfile();
    this.klinik();
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId",
      klinikUser: "klinikUser",
      faskes: "faskes",
      getRolesName: "getRolesName"
    }),
    now() {
      return moment().format("YYYY-MM-DD");
    },
    nowIndonesia() {
      moment.locale("ID");
      return moment().format("dddd, D MMMM YYYY");
    }
  },
  methods: {
    watchImageUploaded() {
      EventBus.$on("image-uploaded", async val => {
        await this.getProfile();
      });
    },
    hasFeatures(value) {
      const features = {
        pic: ["pic_cabang", "pic_pusat"],
        manajemen: ["owner_klinik", "manajemen"],
        lainya: ["perawat", "frontdesk", "apoteker", "kasir", "dokter_klinik"],
        kasir: ["kasir"],
      };
      const roles = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return roles.length > 0 ? true : false;
    },
    klinik() {
      this.klinikUser.forEach(x => {
        if (x.id == this.getKlinikId) this.dataKlinik = x;
      });
    },
    async getProfile() {
      let profile = this.$store.state.user.id;
      try {
        if (this.$router.currentRoute.query.cekAlamat) {
          const res = await this.$axios.get(
            `user/${profile}?klinik_id=${this.getKlinikId}`
          );
          this.klinikAddress = res.data.data.klinik.alamat;
          this.$swal({
            text: `Silakan Lengkapi Alamat Praktik Anda terlebih dahulu!`,
            type: "warning",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(dats => {
            if (dats.value) {
              this.$router.push(`/profile`);
            }
          });
        } else {
          const res = await this.$axios.get(
            `user/${profile}?klinik_id=${this.getKlinikId}`
          );
          const { data } = res.data;
          this.$store.commit("SET_KLINIK_USER", data.kliniks);
          this.dataProfile = data;
          this.getName();
        }
      } catch (err) {
        // console.log(err);
      }
    },
    getName() {
      let shouldSkip = false;
      this.getRolesName.forEach(v => {
        if (shouldSkip) return;

        if (v == "pic_cabang") {
          shouldSkip = true;
          this.nama = this.dataProfile.nama || null;
          return;
        } else if (v == "dokter_klinik") {
          shouldSkip = true;
          this.nama = this.dataProfile.nama || null;
          return;
        } else {
          this.nama = this.dataProfile.nama;
          return;
        }
      });
    },
    async getRawatJalan() {
      try {
        const res = await this.$axios.get(
          `dash-rawat-jalan?from=${this.now}&to=${this.now}`
        );
        const { status, data } = res.data;
      } catch (err) {
        // console.log(err);
      }
    },
    async dashboardPasien() {
      try {
        const res = await this.$axios.get(`dash-pasien`);
        const { status, data } = res;
        if (status) {
          this.totalPasienHariIni = data.data.pasien_hari_ini || 0;
          this.pasienBaruHariIni = data.data.pasien_baru_hari_ini || 0;
          this.nomor_antrean = data.data.nomor_antrian_saat_ini || 0;
          this.pasienBatalHariIni = data.data.pasien_batal_hari_ini || 0;
          this.totalPendapatan = data.data.total_pendapatan_hari_ini || 0;
          this.paketAnda = {
            nama_paket:
              data.data.paket_berlangganan.nama_paket ||
              "Anda belum melakukan pembelian paket apapun",
            durasi_paket: data.data.paket_berlangganan.durasi_paket || "-",
            sisa_kouta: data.data.paket_berlangganan.sisa_kouta || "-",
            habis_berlaku: data.data.paket_berlangganan.habis_berlaku || "-",
            sisa_hari: data.data.paket_berlangganan.sisa_hari || "-"
          };
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getPasienBaru() {
      try {
        const res = await this.$axios.get(`dash-pasien-baru`);
        const {
          status,
          data: {
            data: { today_patient }
          }
        } = res;
        if (status) {
          this.pasienBaruHariIni = today_patient;
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getAntrean() {
      try {
        const res = await this.$axios.get(`dash-antrian`);
        const {
          status,
          data: { nomor_antrian = 0 }
        } = res.data;
        if (status) {
          this.nomor_antrean = nomor_antrian;
        }
      } catch (err) {
        // console.log(err);
      }
    },
    isRole(rolename) {
      let re = new RegExp(rolename, "i");
      return re.test(this.getRolesName);
    }
  }
};
</script>

<style lang="scss">
.background-image {
  background-image: url("./../assets/img/welcome_edited.png");
  background-size: cover;
  background-position: center; /* Center the background image */
}

.background-image-staff {
  background-image: url("./../assets/img/welcome_1.png");
  background-size: cover; 
  background-position: center;
}

.__zoom-dashboard-klinik {
  // zoom: 80%;
  transform: scale(0.81);
  margin-top: -14%;
  width: 124%;
  margin-left: -12%;
  font-size: 12pt;
}

.img-welcome {
  z-index: 0;
}

.img-profile {
  border-radius: 50%;
  width: 136px;
  height: 136px;
  object-fit: cover;
}

.img-outer-text {
  position: absolute;
  font-size: 30px;
  font-weight: 650;
  margin-top: 34px;
  margin-left: 5%;
  z-index: 1;
}

.font-outer-text {
  font-size: 30px;
  font-weight: 650;
}

._text-profile {
  font-size: 16px;
  color: #3b3e66;
  font-weight: 700;
}

.__sub-outer-text {
  position: absolute;
  margin-top: 10%;
  margin-left: 5%;
  font-weight: 620;
  z-index: 2;
  font-size: 18px;
}

.font-sub-outer-text {
  font-weight: 620;
  font-size: 18px;
}

$bg-izd-home: #f2f2f2;
$bg-izd-home-alternate: #d6d6d6;

.apexcharts-title-text {
  font-weight: 800 !important;
}

.tab-izd-home {
  color: #778fad !important;

  ul {
    &[role="tablist"] {
      padding: 0;
      border-color: $bg-izd-home;

      li {
        &:first-child {
          padding: 0;
        }

        padding-left: 12px;

        a {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          border-color: $bg-izd-home-alternate !important;
          background-color: $bg-izd-home-alternate;
          text-transform: capitalize !important;
          color: #fff !important;
          font-weight: 600;

          &.active {
            color: #778fad !important;
            border-color: $bg-izd-home !important;
            background-color: $bg-izd-home;
          }
        }
      }
    }
  }

  .tab-content {
    background-color: $bg-izd-home;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    border-top-right-radius: 12px;
  }
}

.card-dashboard {
  background-repeat: no-repeat !important;
  background-size: 185% !important;
  background-position: center !important;

  @function bgImage($imageName) {
    @return url("../assets/img/dashboard/"+$imageName+".png");
  }

  &.total-pasien-hari-ini {
    background-image: bgImage("total-pasien-hari-ini");
  }

  &.pasien-baru-hari-ini {
    background-image: bgImage("pasien-baru-hari-ini");
  }

  &.no-antrean-saat-ini {
    background-image: bgImage("no-antrean-saat-ini");
  }

  &.jumlah-pasien-batal-hari-ini {
    background-image: bgImage("jumlah-pasien-batal-hari-ini");
  }

  &.total-pendapatan-hari-ini {
    background-image: bgImage("total-pendapatan");
  }
}

@media screen and (max-width: 1200px) {
  .card-dashboard {
    background-size: 240% !important;
  }
}

@media screen and (max-width: 992px) {
  .card-dashboard {
    background-size: 260% !important;
  }

  .__zoom-dashboard-klinik {
    margin-top: -25% !important;
  }
}

@media screen and (max-width: 768px) {
  .card-dashboard {
    background-size: 380% !important;
  }

  .paket-wrapper {
    margin-top: 1rem !important;
  }

  .__zoom-dashboard-klinik {
    margin-top: -46% !important;
  }
}

@media screen and (max-width: 576px) {
  .card-dashboard {
    background-size: 800% !important;
  }

  .__zoom-dashboard-klinik {
    margin-top: -95% !important;
  }
}
.swal2-title {
  font-size: 1.5em !important;
}
</style>